import { render, staticRenderFns } from "./SafetyObservationNewForm.vue?vue&type=template&id=0c9e4fc3&"
import script from "./SafetyObservationNewForm.vue?vue&type=script&lang=js&"
export * from "./SafetyObservationNewForm.vue?vue&type=script&lang=js&"
import style0 from "./SafetyObservationNewForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports